import * as React from 'react';
import { useIntercom } from 'react-use-intercom';
import { useAuth } from 'src/shared/hooks/use-auth';

const { useEffect } = React;

export const useIntercomService = () => {
  const { boot, update } = useIntercom();
  const authData = useAuth((s) => s.userDetails);

  useEffect(() => {
    boot();
    if (authData?.name) {
      update({
        userId: authData.userId,
        name: authData.name || 'User',
        email: authData.email,
        avatar: { type: 'avatar', imageUrl: authData.avatarUrl },
        userHash: authData.intercomUserHash,
      });
    }
  }, [authData]);
};
